import React from 'react'
import {ReactComponent as Check} from '../../assets/check.svg'
import './PagesChecklist.css'


function PagesChecklist(props) {
    return (
        <div className="pagesChecklistWrapper">
          
                <div className="pagesChecklistTitle">
                    {props.subtitle}
                </div>
                
                <div className="pagesList">
                    <div className="pagesChecklist">
                        <Check/>
                        <p>{props.checklist1}</p>
                    </div>
                    <div className="pagesChecklist">
                        <Check/>
                        <p>{props.checklist2}</p>
                    </div>
                    <div className="pagesChecklist">
                        <Check/>
                        <p>{props.checklist3}</p>
                    </div>
                    <div className="pagesChecklist">
                        <Check/>
                        <p>{props.checklist4}</p>
                    </div>
                </div>

  
        </div>
    )
}

export default PagesChecklist
